'use strict';

module.exports = function(state) {
	var isPausedBecauseNotInView = state === 'isPausedBecauseNotInView';
	if (this.isCleared) return;
	if (!isPausedBecauseNotInView) this.isPaused = true;
	cancelAnimationFrame(this.animation);
	this.animating = false;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/pause.js
// module id = 40
// module chunks = 0